import { resetGlobal, getGlobal } from 'reactn';
import { history, BASE_API_URL } from 'meta/constants';

// eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
export function noOp(any: any): any {}

export * from 'oldschooljs/dist/util/index';

export function isValidToken(string: string) {
	return /^[MN][A-Za-z\d]{23}.[\w-]{6}.[\w-]{27}$/.test(string);
}

export function log(str: string) {
	if (process.env.NODE_ENV === 'development') {
		console.log(`[${currentTime()}] ${str}`);
	}
}

export function currentTime() {
	const today = new Date();
	const time = `${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`;
	return time;
}

export function logOut() {
	localStorage.clear();
	resetGlobal();
	history.replace('/');
}

export function toTitleCase(str: string) {
	const splitStr = str.toLowerCase().split(' ');
	for (let i = 0; i < splitStr.length; i++) {
		splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
	}
	return splitStr.join(' ');
}

export const loadState = (key: string) => {
	try {
		const serializedState = localStorage.getItem(key);

		if (serializedState === null) {
			return undefined;
		}
		return JSON.parse(serializedState);
	} catch (err) {
		return undefined;
	}
};

export const saveState = (key: string, state: any) => {
	try {
		const serializedState = JSON.stringify(state);
		localStorage.setItem(key, serializedState);
	} catch (err) {}
};

export async function authedFetch(path: string, method = 'GET', body?: any, headers: any = {}) {
	headers.authentication = getGlobal().token;
	if (body) body = JSON.stringify(body);

	const response = await fetch(`${BASE_API_URL}${path}`, {
		method,
		body,
		headers: { 'Content-Type': 'application/json', ...headers }
	});

	return response.json();
}

export async function apiFetch({
	path,
	method = 'GET',
	body,
	headers = {},
	query
}: {
	path: string;
	method?: string;
	body?: any;
	headers?: Record<string, number>;
	query?: Record<string, string>;
}) {
	if (body) body = JSON.stringify(body);
	const url = new URL(`${BASE_API_URL}${path}`);
	if (query) {
		url.search = new URLSearchParams(query).toString();
	}

	const response = await fetch(url.toString(), {
		method,
		body,
		headers: {
			'Content-Type': 'application/json',
			...headers
		}
	});

	return response.json();
}

export function cleanString(str = '') {
	return str.replace(/[^0-9a-zA-Z]/gi, '').toUpperCase();
}

export function stringMatches(str: string, str2: string): boolean {
	return cleanString(str) === cleanString(str2);
}

export function loadImage(imageSrc: string): Promise<HTMLImageElement> {
	return new Promise((resolve, reject) => {
		const canvasImage = new Image();

		canvasImage.onload = () => resolve(canvasImage);
		canvasImage.onerror = () => reject(new Error('Failed to load image.'));
		canvasImage.src = imageSrc;
	});
}

export function generateHexColorForCashStack(coins: number) {
	if (coins > 999_999_999) {
		return '#fc03df';
	}

	if (coins > 9_999_999) {
		return '#00FF80';
	}

	if (coins > 99_999) {
		return '#FFFFFF';
	}

	return '#FFFF00';
}

export function formatItemStackQuantity(quantity: number) {
	if (quantity > 9999999) {
		return `${Math.floor(quantity / 1000000)}M`;
	} else if (quantity > 99999) {
		return `${Math.floor(quantity / 1000)}K`;
	}
	return quantity.toString();
}

export function saveCtx(ctx: any) {
	const props = [
		'fillStyle',
		'globalAlpha',
		'globalCompositeOperation',
		'font',
		'textAlign',
		'textBaseline',
		'direction',
		'imageSmoothingEnabled'
	];
	const state: { [key: string]: any } = {};
	for (const prop of props) {
		state[prop] = ctx[prop];
	}
	return state;
}

export function restoreCtx(ctx: any, state: any) {
	for (const prop of Object.keys(state)) {
		ctx[prop] = state[prop];
	}
}

export function scrollToEl(id: string) {
	if (!id) return;
	const el = document.getElementById(decodeURI(id));
	if (el) el.scrollIntoView(true);
}

export function removeKeyFromObj<O>(key: keyof O, obj: O) {
	const newObj = { ...obj };
	delete newObj[key];
	return newObj;
}
